var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "walkup-modal" }, [
    _vm.step === 1
      ? _c("div", { staticClass: "walkup-step-1" }, [
          _vm._m(0),
          _c("div", { staticClass: "walkup-body" }, [
            _c("div", { staticClass: "tiers-column" }, [
              _c(
                "div",
                { staticClass: "tier-list" },
                _vm._l(_vm.priceTiers, function(tier) {
                  return _c(
                    "div",
                    {
                      key: tier.id,
                      staticClass: "tier-row",
                      class: { "tier-row-sliding": tier.feeType === "sliding" }
                    },
                    [
                      _c("div", { staticClass: "tier-content" }, [
                        _c("div", { staticClass: "tier-top" }, [
                          _c("div", { staticClass: "tier-info" }, [
                            _c("h4", { staticClass: "tier-name" }, [
                              _vm._v(_vm._s(tier.name))
                            ]),
                            tier.feeType === "fixed"
                              ? _c("p", { staticClass: "tier-price" }, [
                                  _vm._v(
                                    " $" + _vm._s(tier.price) + " per ticket "
                                  )
                                ])
                              : _vm._e(),
                            tier.feeType === "sliding"
                              ? _c("p", { staticClass: "tier-price" }, [
                                  _vm._v(
                                    " $" +
                                      _vm._s(_vm.getSlidingPrice(tier)) +
                                      " per ticket "
                                  )
                                ])
                              : _vm._e(),
                            tier.feeType === "free"
                              ? _c("p", { staticClass: "tier-price" }, [
                                  _vm._v(" Free! ")
                                ])
                              : _vm._e()
                          ]),
                          _c("div", { staticClass: "quantity-picker" }, [
                            _c("span", { staticClass: "quantity-label" }, [
                              _vm._v("Quantity")
                            ]),
                            _c("div", { staticClass: "quantity-controls" }, [
                              _c(
                                "button",
                                {
                                  staticClass: "qty-btn minus",
                                  attrs: {
                                    disabled:
                                      !tier.quantity || tier.quantity <= 0
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.decrementQuantity(tier)
                                    }
                                  }
                                },
                                [_c("span", [_vm._v("−")])]
                              ),
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model.number",
                                    value: tier.quantity,
                                    expression: "tier.quantity",
                                    modifiers: { number: true }
                                  }
                                ],
                                staticClass: "qty-input",
                                attrs: {
                                  type: "number",
                                  min: "0",
                                  max: _vm.maxSale,
                                  readonly: ""
                                },
                                domProps: { value: tier.quantity },
                                on: {
                                  input: function($event) {
                                    if ($event.target.composing) return
                                    _vm.$set(
                                      tier,
                                      "quantity",
                                      _vm._n($event.target.value)
                                    )
                                  },
                                  blur: function($event) {
                                    return _vm.$forceUpdate()
                                  }
                                }
                              }),
                              _c(
                                "button",
                                {
                                  staticClass: "qty-btn plus",
                                  attrs: {
                                    disabled: _vm.totalQuantity >= _vm.maxSale
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.incrementQuantity(tier)
                                    }
                                  }
                                },
                                [_c("span", [_vm._v("+")])]
                              )
                            ])
                          ])
                        ]),
                        tier.feeType === "sliding"
                          ? _c("div", { staticClass: "slider-section" }, [
                              _c("div", { staticClass: "slider-container" }, [
                                _c(
                                  "div",
                                  {
                                    staticClass: "floating-price",
                                    style: _vm.getFloatingPriceStyle(tier)
                                  },
                                  [
                                    _vm._v(
                                      " $" +
                                        _vm._s(_vm.getSlidingPrice(tier)) +
                                        " "
                                    )
                                  ]
                                ),
                                _c("input", {
                                  staticClass: "price-slider",
                                  attrs: {
                                    type: "range",
                                    min: tier.minPrice,
                                    max: tier.maxPrice
                                  },
                                  domProps: {
                                    value: _vm.getSlidingPrice(tier)
                                  },
                                  on: {
                                    input: function($event) {
                                      return _vm.updateSlidingPrice(
                                        tier,
                                        $event.target.value
                                      )
                                    }
                                  }
                                }),
                                _c("div", { staticClass: "slider-labels" }, [
                                  _c("span", [
                                    _vm._v("$" + _vm._s(tier.minPrice))
                                  ]),
                                  _c("span", [
                                    _vm._v("$" + _vm._s(tier.maxPrice))
                                  ])
                                ])
                              ])
                            ])
                          : _vm._e()
                      ])
                    ]
                  )
                }),
                0
              )
            ]),
            _c("div", { staticClass: "summary-column" }, [
              _c("h4", { staticClass: "order-summary-title" }, [
                _vm._v("ORDER SUMMARY")
              ]),
              _c("div", { staticClass: "order-summary-box" }, [
                _c(
                  "div",
                  { staticClass: "tier-subtotals" },
                  _vm._l(_vm.priceTiers, function(tier) {
                    return _c(
                      "div",
                      {
                        key: "subtotal-" + tier.id,
                        staticClass: "tier-subtotal-row",
                        class: {
                          "tier-subtotal-row-sliding":
                            tier.feeType === "sliding"
                        }
                      },
                      [
                        _c("span", { staticClass: "tier-subtotal" }, [
                          _vm._v("$" + _vm._s(_vm.getTierSubtotal(tier)))
                        ])
                      ]
                    )
                  }),
                  0
                ),
                _c("div", { staticClass: "order-details" }, [
                  _c("div", { staticClass: "order-row" }, [
                    _c("span", [_vm._v("Subtotal")]),
                    _c("span", [_vm._v("$" + _vm._s(_vm.subtotal))])
                  ]),
                  _c("div", { staticClass: "order-row" }, [
                    _c("span", [_vm._v("Sales Tax")]),
                    _c("span", [_vm._v("$" + _vm._s(_vm.salesTax))])
                  ])
                ]),
                _c("div", { staticClass: "order-total-row" }, [
                  _c("span", [_vm._v("Total")]),
                  _c("span", [_vm._v("$" + _vm._s(_vm.orderTotal))])
                ])
              ])
            ])
          ]),
          _c("div", { staticClass: "walkup-footer" }, [
            _c(
              "button",
              {
                staticClass: "button is-primary is-fullwidth checkout-btn",
                attrs: { disabled: _vm.totalQuantity === 0 },
                on: { click: _vm.goToStep2 }
              },
              [_vm._v(" Checkout ")]
            )
          ])
        ])
      : _vm._e(),
    _vm.step === 2
      ? _c("div", { staticClass: "walkup-step-2" }, [
          _c("div", { staticClass: "checkout-content" }, [
            _c("h1", [_vm._v("Checkout")]),
            _c("div", { staticClass: "field" }, [
              _c("label", { staticClass: "label" }, [
                _vm._v("First Name (optional)")
              ]),
              _c("div", { staticClass: "control" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.firstName,
                      expression: "firstName"
                    }
                  ],
                  staticClass: "input",
                  attrs: { type: "text", placeholder: "First Name" },
                  domProps: { value: _vm.firstName },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) return
                      _vm.firstName = $event.target.value
                    }
                  }
                })
              ])
            ]),
            _c("div", { staticClass: "field" }, [
              _c("label", { staticClass: "label" }, [
                _vm._v("Last Name (optional)")
              ]),
              _c("div", { staticClass: "control" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.lastName,
                      expression: "lastName"
                    }
                  ],
                  staticClass: "input",
                  attrs: { type: "text", placeholder: "Last Name" },
                  domProps: { value: _vm.lastName },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) return
                      _vm.lastName = $event.target.value
                    }
                  }
                })
              ])
            ]),
            _c("div", { staticClass: "field" }, [
              _c("label", { staticClass: "label" }, [
                _vm._v("Email (optional)")
              ]),
              _c("div", { staticClass: "control" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.email,
                      expression: "email"
                    }
                  ],
                  staticClass: "input",
                  attrs: { type: "email", placeholder: "Email" },
                  domProps: { value: _vm.email },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) return
                      _vm.email = $event.target.value
                    }
                  }
                })
              ])
            ]),
            _c("div", { staticClass: "field" }, [
              _c("label", { staticClass: "label" }, [
                _vm._v("Note (optional)")
              ]),
              _c("div", { staticClass: "control" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.note,
                      expression: "note"
                    }
                  ],
                  staticClass: "input",
                  attrs: {
                    type: "text",
                    placeholder:
                      "Add artist's name and/or the guest's relationship to the artists"
                  },
                  domProps: { value: _vm.note },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) return
                      _vm.note = $event.target.value
                    }
                  }
                })
              ])
            ]),
            _c("div", { staticClass: "field checkin-field" }, [
              _c("label", { staticClass: "checkbox" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.shouldCheckIn,
                      expression: "shouldCheckIn"
                    }
                  ],
                  attrs: { type: "checkbox" },
                  domProps: {
                    checked: Array.isArray(_vm.shouldCheckIn)
                      ? _vm._i(_vm.shouldCheckIn, null) > -1
                      : _vm.shouldCheckIn
                  },
                  on: {
                    change: function($event) {
                      var $$a = _vm.shouldCheckIn,
                        $$el = $event.target,
                        $$c = $$el.checked ? true : false
                      if (Array.isArray($$a)) {
                        var $$v = null,
                          $$i = _vm._i($$a, $$v)
                        if ($$el.checked) {
                          $$i < 0 && (_vm.shouldCheckIn = $$a.concat([$$v]))
                        } else {
                          $$i > -1 &&
                            (_vm.shouldCheckIn = $$a
                              .slice(0, $$i)
                              .concat($$a.slice($$i + 1)))
                        }
                      } else {
                        _vm.shouldCheckIn = $$c
                      }
                    }
                  }
                }),
                _c("span", { staticClass: "checkin-label" }, [
                  _vm._v("Check In")
                ])
              ])
            ]),
            _c(
              "div",
              { staticClass: "checkout-buttons" },
              [
                _c(
                  "button",
                  {
                    staticClass: "button is-primary back-btn",
                    on: { click: _vm.goToStep1 }
                  },
                  [_vm._v(" Back ")]
                ),
                parseFloat(_vm.orderTotal) > 0
                  ? [
                      _c(
                        "button",
                        {
                          staticClass: "button is-primary cash-btn",
                          on: {
                            click: function($event) {
                              return _vm.add("Cash")
                            }
                          }
                        },
                        [_vm._v(" Cash ")]
                      ),
                      _c(
                        "button",
                        {
                          staticClass: "button is-primary credit-btn",
                          on: {
                            click: function($event) {
                              return _vm.add("Credit")
                            }
                          }
                        },
                        [_vm._v(" Credit ")]
                      )
                    ]
                  : _c(
                      "button",
                      {
                        staticClass: "button is-primary add-walkup-btn",
                        on: {
                          click: function($event) {
                            return _vm.add("Free")
                          }
                        }
                      },
                      [_vm._v(" Add Walkup ")]
                    )
              ],
              2
            )
          ])
        ])
      : _vm._e()
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "walkup-header" }, [
      _c("h1", [_vm._v("Add Walkup")])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }